/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Ai_Help_PromptInputs */

const en_serve_ai_help_prompt = /** @type {(inputs: Serve_Ai_Help_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read https://bystep.dev/agent-guide.md first, then guide me step by step to set up Bystep on my computer (the "my computer" path). I am not a programmer.`)
};

const id_serve_ai_help_prompt = /** @type {(inputs: Serve_Ai_Help_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca https://bystep.dev/agent-guide.md dulu, lalu pandu saya langkah demi langkah memasang Bystep di komputer saya (jalur "komputer saya"). Saya bukan programmer.`)
};

/**
* | output |
* | --- |
* | "Read https://bystep.dev/agent-guide.md first, then guide me step by step to set up Bystep on my computer (the \"my computer\" path). I am not a programmer." |
*
* @param {Serve_Ai_Help_PromptInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_ai_help_prompt = /** @type {((inputs?: Serve_Ai_Help_PromptInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Ai_Help_PromptInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_ai_help_prompt(inputs)
	return en_serve_ai_help_prompt(inputs)
});